export enum CurrencySymbol {
  BRL = 'R$',
}
